__turbopack_context__.v({
  "className": "montserrat_10178ae7-module__L0H0mW__className",
  "variable": "montserrat_10178ae7-module__L0H0mW__variable",
});
